var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"earth-wrapper",class:{'appearance': _vm.isCover}},[_vm._m(0),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"earth"},[_c('img',{attrs:{"src":require("@/assets/img/earth.webp"),"alt":""}})])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"moon"},[_c('img',{attrs:{"src":require("@/assets/img/Repost-symbol__white.svg"),"alt":""}})])
}]

export { render, staticRenderFns }